import { Text } from 'designSystem/components/Text'
import React from 'react'
import styled from 'styled-components'

const ScoreContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  background-color: color-mix(in oklch, var(--primary) 13%, transparent);
  padding: 0.375rem 0.5rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
`

const ScoreGroup = styled.span`
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
  font-size: 0.625rem;
`

export interface RelevanceScoreBarProps {
  relevance?: number
  detailScores?: Record<string, number>
  showIndividualScores?: boolean
}

export const RelevanceScoreBar: React.FC<RelevanceScoreBarProps> = ({
  relevance,
  detailScores,
  showIndividualScores = true,
}) => {
  const hasDetailScores =
    showIndividualScores && detailScores && Object.keys(detailScores).length > 0
  if (
    relevance === undefined &&
    (!detailScores || Object.keys(detailScores).length === 0)
  ) {
    return null
  }

  return (
    <ScoreContainer>
      {relevance !== undefined && (
        <ScoreGroup>
          <Text as='span' size='xxs' weight='medium' color='muted'>
            Relevance
          </Text>
          <Text as='span' size='xxs' weight='bold'>
            {relevance.toFixed(2)}
          </Text>
        </ScoreGroup>
      )}
      {hasDetailScores &&
        Object.entries(detailScores).map(([name, score]) => (
          <ScoreGroup key={name}>
            <Text as='span' size='xxs' weight='medium' color='muted'>
              {name}
            </Text>
            <Text as='span' size='xxs'>
              {score.toFixed(3)}
            </Text>
          </ScoreGroup>
        ))}
    </ScoreContainer>
  )
}
